import PropTypes from 'prop-types'
// @mui
import { Box, List, Stack } from '@mui/material'
// locales
import { useLocales } from '../../../locales'
//
import { StyledSubheader } from './styles'
import NavList from './NavList'
import Can from '../../can'
import { If } from '../../conditional'

// ----------------------------------------------------------------------

NavSectionVertical.propTypes = {
  sx: PropTypes.object,
  data: PropTypes.array,
}

export default function NavSectionVertical({ data, sx, ...other }) {
  const { translate } = useLocales()

  return (
    <Stack sx={sx} {...other}>
      {data.map((group) => {
        const key = group.subheader || group.items[0].title

        // Aqui renderiza a navegação.
        return (
          <List key={key} disablePadding sx={{ px: 2 }}>
            {group.image && (
              <Stack alignItems="center" sx={{ pt: 2, pb: 0.5 }}>
                <Box
                  component="img"
                  src={group.image}
                  alt={group.subheader || ''}
                  sx={{
                    width: '80%',
                    aspectRatio: '16 / 9',
                    objectFit: 'cover',
                    borderRadius: 1.5,
                  }}
                />
              </Stack>
            )}

            <If condition={group.subheader}>
              <Can perform={group.permission}>
                <StyledSubheader disableSticky>{translate(group.subheader)}</StyledSubheader>
              </Can>
            </If>

            {group.items.map((list) => (
              <Can key={list.title + list.path} perform={list.permission}>
                <NavList
                  key={list.title + list.path}
                  data={list}
                  depth={1}
                  hasChild={!!list.children}
                />
              </Can>
            ))}
          </List>
        )
      })}
    </Stack>
  )
}
